import { render, staticRenderFns } from "./CommentTile.vue?vue&type=template&id=5c265f9a"
import script from "./CommentTile.vue?vue&type=script&lang=js"
export * from "./CommentTile.vue?vue&type=script&lang=js"
import style0 from "./CommentTile.vue?vue&type=style&index=0&id=5c265f9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports